import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { ProfileDetails, GeneralSettings } from './components';

const useStyles = makeStyles(() => ({
  root: {}
}));

const General = props => {
  const { className,userprofile, ...rest } = props;

  const classes = useStyles();
  const [profile, setProfile] = useState({
    id: 1,
    image: "",
    title:"Update Title",
    description: "Detail Content",
    commodity:{
      name: "Edible Oil"
    },
    status : true
   });



  if (!userprofile) {
    return null;
  }

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
    >
      {/* <Grid
        item
        lg={4}
        md={6}
        xl={3}
        xs={12}
      >
        <ProfileDetails profile={profile} />
      </Grid> */}
      <Grid
        item
        lg={12}
        md={12}
        xl={12}
        xs={12}
      >
        <GeneralSettings profile={userprofile} />
      </Grid>
    </Grid>
  );
};

General.propTypes = {
  className: PropTypes.string
};

export default General;
